import React, { useEffect, useState } from "react";
import ProfileImage from "./ProfileImage";
import { employeePreview } from "../../utils/employee";
import { classnames } from "../../utils/text";
import { preventEvent } from "../../utils/element";
import { shallowEqual, useSelector } from "react-redux";
import { get } from "lodash";

const Profile = ({
  data,
  employeeIdx,
  className,
  isPreview = true,
  onClick,
  isProfileImage = false,
  useEmpty = false,
  emptyLabal = '비공개'
}) => {

  const { employees } = useSelector(
    (store) => ({
      employees: store.Data.employees,
    }),
    shallowEqual
  );
  const [_data, _setData] = useState({});

  useEffect(() => {
    if (employeeIdx || (data && data.idx)) {
      const targetIdx = employeeIdx || get(data, 'employeeIdx') || get(data, 'idx') || get(data, 'reqEmployeeIdx');
      const target = employees.find(e => e.idx === targetIdx);
      _setData({ ...data, ...target, isOutsider: !target });
    }
  }, [employeeIdx, employees, data]);

  const showPreviewEmployee = (e) => {
    if (isPreview && !_data.isOutsider) {
      preventEvent(e);
      employeePreview(_data.idx);
    }
    return false;
  };
  return <>{
    !employeeIdx && useEmpty ? '-' : <div
      className={classnames("user-profile", className)}
      onClick={onClick || showPreviewEmployee}
    >
      {(isProfileImage || !_data.isOutsider) && <ProfileImage data={_data} />}
      <span className="user-name">
        {_data.name || emptyLabal}
      </span>
    </div>
  }
  </>
};
export {
  Profile,
  ProfileImage
};
export default Profile;
